import { render } from "./ContactLocationEventDetails.vue?vue&type=template&id=4f05099f&scoped=true"
import script from "./ContactLocationEventDetails.vue?vue&type=script&lang=js"
export * from "./ContactLocationEventDetails.vue?vue&type=script&lang=js"

import "./ContactLocationEventDetails.vue?vue&type=style&index=0&id=4f05099f&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f05099f"]])

export default __exports__